import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { DadoCabecalho, ItemMenuGrp, MenuItem } from 'govbr-lib';
import { UsuarioService } from 'src/app/components/usuario/service/usuario.service';
import { UsuarioDTO } from 'src/app/models/UsuarioDTO';

@Component({
  selector: 'gov-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  itemsMenu: MenuItem[] = [];
  isOpen: boolean;

  usuario: UsuarioDTO;

  dadoCabecalho: DadoCabecalho = { nomeProduto: 'Editor de Propostas' };
  menuGrp: ItemMenuGrp[] = [];

  constructor(public dialog: MatDialog, private usuarioService: UsuarioService) { }

  ngOnInit() {
    this.usuarioService.retornaUser().subscribe(usuario => {
      this.usuario = usuario;
    })

    this.carregarItensMenu();

    if (this.usuario.perfil == 0) {
      this.itemsMenu.splice(0, 2);
    }
  }

  carregarItensMenu() {
    this.itemsMenu = [
      {
        nivel: 1,
        nome: 'Cadastros',
        showIcon: true,
        iconeGuia: false,
        uid: '',
        children: [
          {
            nivel: 2,
            nome: 'Serviços',
            rota: 'servicos',
            showIcon: true,
            iconeGuia: true,
            uid: '',
          },
          {
            nivel: 2,
            nome: 'Áreas de negócio',
            rota: 'areas-negocio',
            showIcon: true,
            iconeGuia: true,
            uid: '',
          },
          {
            nivel: 2,
            nome: 'Usuários',
            rota: 'usuarios',
            showIcon: true,
            iconeGuia: true,
            uid: '',
          },
        ]
      },
      {
        nivel: 1,
        nome: 'Parâmetros',
        showIcon: true,
        iconeGuia: false,
        uid: '',
        children: [
          {
            nivel: 2,
            nome: 'Equipes por UF',
            rota: 'parametros/equipes',
            showIcon: true,
            iconeGuia: true,
            uid: '',
          }
        ]
      }, {

        nivel: 1,
        nome: 'Portifólio de serviços',
        rota: 'portifolio',
        showIcon: true,
        iconeGuia: true,
        uid: '',
        children: []
      }
      , {
        nivel: 2,
        nome: 'Suporte',
        showIcon: true,
        iconeGuia: true,
        rota: 'portifolio',
        uid: '',
      }
    ];
  }


}
